import { Alert } from '@material-ui/lab';
import { Theme, withStyles } from '@material-ui/core/styles';
import { BrandColors } from '../../constants/brandColors';

export const StyledAlert = withStyles((theme: Theme) => ({
  root: {
    borderRadius: 2,
    padding: 16,
    boxSizing: 'border-box',
  },
  outlinedInfo: {
    background: BrandColors.grey95,
    border: `1px solid ${BrandColors.grey77}`,
  },
  outlinedError: {
    background: BrandColors.lightRed39,
    border: `1px solid ${theme.palette.error.main}`,
  },
  outlinedSuccess: {
    background: BrandColors.grey95,
    border: `1px solid ${theme.palette.primary.main}`,
  },
  message: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 16,
    lineHeight: '24px',
    color: theme.palette.text.primary,
    padding: 0,
  },
}))(Alert);
